import React from "react";
import {
  ComputerDesktopIcon,
  Square3Stack3DIcon,
  ArrowsPointingOutIcon,
  Cog6ToothIcon,
  CloudArrowDownIcon,
} from "@heroicons/react/24/outline";

const TechnicalExpertise = () => {
  const cardData = [
    {
      label: "Full-Stack Digital Product Development",
      description:
        "We manage every digital product stage, delivering tailored, scalable solutions with diverse tech expertise.",
    },
    {
      label: "AI Systems Modernization",
      description:
        "We transform legacy systems into modern platforms using the latest AI technologies.",
    },
    {
      label: "Microservices & APIs",
      description:
        "Our microservices approach and APIs ensure system resilience, scalability, and seamless integration.",
    },
    {
      label: "DevSecOps & Developer Experience",
      description:
        "Security is integral to our development, paired with an optimized developer experience for swift market delivery.",
    },
    {
      label: "Cloud Platforms & Tooling",
      description:
        "We harness top cloud platforms, offering robust solutions and streamlining cloud processes.",
    },
    {
      label: "Site Reliability Engineering",
      description:
        "With a focus on uptime, we proactively monitor and optimize platforms for maximum reliability.",
    },
  ];

  return (
    <section className="flex flex-col">
      <div className="text-center px-4 pt-16 pb-8">
        <h2 className="text-4xl font-bold text-gray-900">
          Our strength lies in our deep{" "}
          <span className="text-[#5800C0]">expertise.</span>
        </h2>
      </div>

      <div className="rounded-2xl mx-4 md:mx-16 p-4 md:p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {cardData.map((item) => (
            <div
              key={item.label}
              className="bg-[#1E1152] rounded-xl p-6 flex flex-col gap-3"
            >
              <p className="font-bold text-xl text-white leading-snug min-h-[3.5rem]">
                {item.label}
              </p>
              <p className="text-base text-gray-300 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnicalExpertise;
